module.exports = __webpack_public_path__ + "static/img/buy.5eaa988.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/buy.png
// module id = 1871
// module chunks = 0